import { render, staticRenderFns } from "./BuscaEndereco.vue?vue&type=template&id=2c141b58&"
import script from "./BuscaEndereco.vue?vue&type=script&lang=js&"
export * from "./BuscaEndereco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports